import React, { useEffect } from "react";
import { TextField } from "@material-ui/core";
import { checkIsNullUndefined, getDate } from "../../../commons/Utils";
import { CommonStyles } from "../../../commons/CommonStyles";
import { UnifyAccountsStyles } from "../UnifyAccountsStyles";

export function CheckBoxInput(props) {
  const commonClasses = CommonStyles();
  const classes = UnifyAccountsStyles();
  const { attribute, handleInputSelected } = props;

  useEffect(() => { }, []);

  const handleChange = () => { }

  return (
    // <Grid item xs={12}>
    <TextField
      value={checkIsNullUndefined(attribute?.value) ? " " : attribute.codeAttribute === "FNA" ? getDate(attribute.value, true) : attribute.value}
      variant="outlined"
      fullWidth
      name="textbox"
      color="secondary"
      label={attribute?.nameAttribute}
      onClick={(event) => handleInputSelected(event, attribute)}
      onChange={handleChange}
      focused={attribute?.checked}
      type={"text"}
      inputProps={{ style: { cursor: "pointer" } }}
    />
    // </Grid>
  );
}
